import { useQuery } from '@apollo/client';
import { TransactionEntryDocument } from '../../graphql/generated';
import { CashflowTransactionEntry } from './types';
import { useFinancialEntityMap } from './useFinancialEntityMap';
import { useTransactionEntries } from './useTransactionEntries';
import { useTransactionEntryCategories } from './useTransactionEntryCategories';

// TODO: Make it less complicated to get a single CashflowTransactionEntry
// https://linear.app/plenty/issue/PLE-1009
export const useTransactionEntry = (
    transactionEntryId: string | undefined
): {
    loading: boolean;
    transactionEntry: CashflowTransactionEntry | null | undefined;
} => {
    const {
        data: transactionEntryQuery,
        loading: transactionEntryQueryLoading,
    } = useQuery(
        TransactionEntryDocument,
        transactionEntryId
            ? { variables: { id: transactionEntryId } }
            : { skip: true }
    );

    const {
        transactionEntryCategoriesMapById,
        transactionEntryCategoriesLoading,
    } = useTransactionEntryCategories();

    const { financialEntityMap, financialEntityMapLoading } =
        useFinancialEntityMap();

    const transactionEntries = useTransactionEntries({
        transactionEntries: transactionEntryQuery?.transactionEntry
            ? [transactionEntryQuery.transactionEntry]
            : [],
        financialEntityMap,
        transactionEntryCategoriesMapById,
    });

    return {
        loading:
            transactionEntryCategoriesLoading ||
            transactionEntryQueryLoading ||
            financialEntityMapLoading,
        transactionEntry: transactionEntries.at(0),
    };
};
